/**
 * Utility functions for handling domain-based branding
 */

export const getDomainBasedBrandInfo = () => {
	const { hostname } = window.location;

	const brandConfigs = {
		'portal.getaloop.com.mt': {
			title: 'Loop Mobility',
			description: 'Loop Mobility - Your reliable transportation solution in Malta.',
			companyName: 'Loop Mobility',
		},
		'taxi.handsonsystems.com': {
			title: 'Handson Taxi',
			description:
				'Handson Taxi is a taxi company that provides taxi services in the city of Malta.',
			companyName: 'Handson Taxi',
		},
		'mft.handsontaxi.com': {
			title: 'Malta Free Port',
			description: 'Malta Free Port - Your gateway to efficient port services in Malta.',
			companyName: 'Malta Free Port',
		},
		// Add more domains as needed
	};

	// Return specific config for hostname or default to Handson Taxi
	return (
		brandConfigs[hostname] || {
			title: 'Handson Taxi',
			description:
				'Handson Taxi is a taxi company that provides taxi services in the city of Malta.',
			companyName: 'Handson Taxi',
		}
	);
};

export const getBrandTitle = () => {
	return getDomainBasedBrandInfo().title;
};

export const getBrandDescription = () => {
	return getDomainBasedBrandInfo().description;
};

export const getCompanyName = () => {
	return getDomainBasedBrandInfo().companyName;
};
